<template>
  <div ref="auctionDynamic" class="auctionDynamic-w">
    <div
      ref="titleRef"
      class="title"
      :style="{ top: auctionDynamicScrollTop + 'px' }"
    >
      在线竞价大厅
    </div>

    <div
      ref="col_title"
      class="col-title-w"
      :style="{
        'padding-top': titleH - 1 + 'px',
        top: auctionDynamicScrollTop + 'px',
      }"
    >
      <div class="col-i text-omit" style="width: 127px">项目编号</div>
      <div class="col-i text-omit" style="width: 143px">项目名称</div>
      <div class="col-i text-omit" style="width: 86px">竞价方式</div>
      <div class="col-i text-omit" style="width: 161px">报名截止时间</div>
      <div class="col-i text-omit" style="width: 161px">竞价开始时间</div>
      <div class="col-i text-omit" style="width: 110px">底价</div>
      <div class="col-i text-omit" style="width: 98px">当前报价</div>
      <div class="col-i text-omit" style="width: 156px">剩余时间</div>
    </div>

    <div
      ref="dataW"
      class="data-c-w"
      :style="{ 'padding-top': colTitleH + 'px' }"
    >
      <!-- 进行中的数据 -->
      <SeamlessScroll
        ref="ongoingW"
        custom-key="ongoing"
        :list="ongoingDynamicData"
      >
        <template v-slot:scrollInner="{ item }">
          <router-link
            target="_blank"
            :to="`/auction/detail?projectNo=${item.projectNo}`"
            :class="'row-data-w ' + rowDataClass(item.auctionState)"
          >
            <div
              class="row-i text-omit"
              style="width: 127px"
              :title="item.projectNo"
            >
              {{ item.projectNo }}
            </div>
            <div
              class="row-i text-omit"
              style="width: 143px"
              :title="item.title"
            >
              {{ item.title }}
            </div>
            <div
              class="row-i text-omit"
              style="width: 86px"
              :title="item.auctionMode"
            >
              {{ auctionModeKey[item.auctionMode] }}
            </div>
            <div
              class="row-i text-omit"
              style="width: 161px"
              :title="item.applyEndTime"
            >
              {{ item.applyEndTime }}
            </div>
            <div
              class="row-i text-omit"
              style="width: 161px"
              :title="item.auctionStartTime"
            >
              {{ item.auctionStartTime }}
            </div>
            <div
              class="row-i text-omit"
              style="width: 110px"
              :title="
                item.floorPrice + '元' + (item.priceUnitDesc ? '/' + item.priceUnitDesc : '')
              "
            >
              {{ item.floorPrice + '元' + (item.priceUnitDesc ? '/' + item.priceUnitDesc : '') }}
            </div>
            <div
              class="row-i text-omit"
              style="width: 98px"
              :title="
                item.currentPrice + '元' + (item.priceUnitDesc ? '/' + item.priceUnitDesc : '')
              "
            >
              {{ item.currentPrice + '元' + (item.priceUnitDesc ? '/' + item.priceUnitDesc : '') }}
            </div>
            <div
              class="row-i text-omit text_center"
              style="width: 156px"
              :title="
                isProjectEnd(item.auctionState)
                  ? '已结束'
                  : (item.d ? item.d + '天' : '') +
                    (item.h + '时') +
                    (item.m + '分') +
                    (item.s + '秒')
              "
            >
              <span v-if="isProjectEnd(item.auctionState)">已结束</span>
              <span v-else>
                <span v-if="item.d" class="span_1">{{ item.d }}天</span>
                <span class="span_1">{{ item.h }}时</span>
                <span class="span_1">{{ item.m }}分</span>
                <span>{{ item.s }}秒</span></span>
            </div>
          </router-link>
        </template>
      </SeamlessScroll>

      <!-- 已完成的数据 -->
      <SeamlessScroll
        custom-key="complete"
        :list="completeDynamicData"
      >
        <template v-slot:scrollInner="{ item }">
          <router-link
            target="_blank"
            :to="`/auction/detail?projectNo=${item.projectNo}`"
            :class="'row-data-w ' + rowDataClass(item.auctionState)"
          >
            <div
              class="row-i text-omit"
              style="width: 127px"
              :title="item.projectNo"
            >
              {{ item.projectNo }}
            </div>
            <div
              class="row-i text-omit"
              style="width: 143px"
              :title="item.title"
            >
              {{ item.title }}
            </div>
            <div
              class="row-i text-omit"
              style="width: 86px"
              :title="item.auctionMode"
            >
              {{ auctionModeKey[item.auctionMode] }}
            </div>
            <div
              class="row-i text-omit"
              style="width: 161px"
              :title="item.applyEndTime"
            >
              {{ item.applyEndTime }}
            </div>
            <div
              class="row-i text-omit"
              style="width: 161px"
              :title="item.auctionStartTime"
            >
              {{ item.auctionStartTime }}
            </div>
            <div
              class="row-i text-omit"
              style="width: 110px"
              :title="
                item.floorPrice + '元' + (item.priceUnitDesc ? '/' + item.priceUnitDesc : '')
              "
            >
              {{ item.floorPrice + '元' + (item.priceUnitDesc ? '/' + item.priceUnitDesc : '')  }}
            </div>
            <div
              class="row-i text-omit"
              style="width: 98px"
              :title="
                item.currentPrice + '元' + (item.priceUnitDesc ? '/' + item.priceUnitDesc : '')
              "
            >
              {{ item.currentPrice + '元' + (item.priceUnitDesc ? '/' + item.priceUnitDesc : '')  }}
            </div>
            <div
              class="row-i text-omit text_center"
              style="width: 156px"
              :title="
                isProjectEnd(item.auctionState)
                  ? '已结束'
                  : (item.d ? item.d + '天' : '') +
                    (item.h + '时') +
                    (item.m + '分') +
                    (item.s + '秒')
              "
            >
              <span v-if="isProjectEnd(item.auctionState)">已结束</span>
              <span
                v-else
              ><span v-if="item.d" class="span_1">{{ item.d }}天</span><span class="span_1">{{ item.h }}时</span><span class="span_1">{{ item.m }}分</span><span>{{ item.s }}秒</span></span>
            </div>
          </router-link>
        </template>
      </SeamlessScroll>
    </div>

    <!-- 状态 -->
    <div class="status-w" :style="{ bottom: -auctionDynamicScrollTop + 'px' }">
      <span class="state-i">
        <span class="state-icon" style="background: #fff" />
        <span class="state-des" style="color: #fff">未开始</span>
      </span>
      <span class="state-i" style="margin: 0 37px">
        <span class="state-icon" style="background: #e0de1e" />
        <span class="state-des" style="color: #e0de1e">进行中</span>
      </span>
      <span class="state-i">
        <span class="state-icon" style="background: #de1818" />
        <span class="state-des" style="color: #de1818">已结束</span>
      </span>
    </div>
  </div>
</template>

<script>
import { auction_home } from '@/api/portal'
import { MySocket } from '@/utils/webSocket'
import { mapGetters } from 'vuex'
import { uuid,  tranTimeFormat, numTurnText } from '@/utils'

import SeamlessScroll from '@/components/base/SeamlessScroll.vue'
export default {
  components: {
    SeamlessScroll
  },

  data() {
    return {
      auctionDynamicScrollTop: 0,
      titleH: 0, //
      colTitleH: 0,
      staticDataH: 0, // 静止数据高度
      comValidScrollH: 0, // 滚动数据高度
      rowDataTextClass: '', // 行样式
      auctionModeKey: {
        0: '阶梯竞价',
        1: '自由竞价'
      },
      websocket: null,
      refreshTime: null, // 列表刷新定时器
      rows: 20, // 查询列表条数

      completeCountTimer: null,
      ongoingCountTimer: null,

      ongoingDynamicData: [], // 列表数据（进行中的）
      completeDynamicData: [] // 列表数据（已完成的）
    }
  },

  computed: {
    ...mapGetters(['siteInfo']),

    // 格式化金额
    formatMoney: function() {
      return function(num) {
        return Number(num).toLocaleString()
      }
    },
    // 不同状态行样式
    rowDataClass() {
      return function(state) {
        switch (state) {
          case 0:
            return 'deal_state_0'
          case 1:
          case 3:
            return 'deal_state_1'
          case 5:
          case 4:
            return 'deal_state_2'
          default:
            return 'deal_state_0'
        }
      }
    },
    // 项目是否已结束（包含中止）
    isProjectEnd() {
      return function(stateCode) {
        return [4, 5].includes(stateCode)
      }
    }
  },
  watch:{
    siteInfo:{
      handler(n){
        if(Object.keys(n).length){
          this.getAuctionDynamicData()
          this.$nextTick(() => {
            this.titleH = this.$refs.titleRef.offsetHeight
            this.colTitleH = this.$refs.col_title.offsetHeight + this.titleH
          })
        }
      },
      immediate:true,
      deep:true
    }
  },
  mounted() {

  },
  destroyed() {
    this.websocket?.stompClient?.disconnect() // 关闭socket连接
    window.removeEventListener('online', this.handleWsOnline)
    window.removeEventListener('offline', this.handleWsOffline)
    clearInterval(this.refreshTime) // 刷新列表定时器
  },
  methods: {
    // 获取竞拍大厅数据列表 api
    async getAuctionDynamicData(params) {
      const { data } = await auction_home(
        params || { rows: this.rows, uid: uuid(13) }
      ) // 如果是动态变化的数据，必须设置uid，否则浏览器会缓存！

      // data[0].auctionState = 0
      // data[1].auctionState = 1
      // data[2].auctionState = 1
      // data[3].auctionState = 0
      // data[4].auctionState = 0
      // data[5].auctionState = 1
      // data[6].auctionState = 1
      // data[7].auctionState = 1
      // data[8].auctionState = 0
      // data[9].auctionState = 0
      // data[10].auctionState = 0
      // data[11].auctionState = 4
      // data[12].auctionState = 5
      // data[13].auctionState = 4
      // data[14].auctionState = 4
      // data[15].auctionState = 4
      // data[16].auctionState = 5
      // data[17].auctionState = 5
      // data[18].auctionState = 5
      // data[19].auctionState = 5
      // data[20].auctionState = 5
      // data[21].auctionState = 5
      // data[22].auctionState = 5
      // data[23].auctionState = 5
      // data[24].auctionState = 5
      // data[25].auctionState = 5
      // data[26].auctionState = 5
      // data[27].auctionState = 5
      // data[28].auctionState = 5

      this.loadOngoingDynamicData(data) // 进行中
      this.loadCompleteDynamicData(data) // 已结束

      this.getComValidScrollH()
      this.setRefreshCountDown() // 设置刷新列表时长

      this.setListData(this.ongoingDynamicData, 'ongoingCountTimer')
      this.initSocket(this.ongoingDynamicData, 'ongoingCountTimer')
    },

    // 加载已完成的数据
    loadCompleteDynamicData(data) {
      this.completeDynamicData = []
      this.completeDynamicData = data.filter((i) =>
        [4, 5].includes(i.auctionState)
      )
      this.completeDynamicData.forEach((i) => {
        i.floorPrice = numTurnText(i.floorPrice)
        i.currentPrice = numTurnText(i.currentPrice)
      })
    },
    // 加载进行中的数据
    loadOngoingDynamicData(data) {
      this.ongoingDynamicData = []
      this.ongoingDynamicData = data.filter((i) =>
        [0, 1, 2, 3].includes(i.auctionState)
      )
      this.ongoingDynamicData.forEach((i) => {
        i.floorPrice = numTurnText(i.floorPrice)
        i.currentPrice = numTurnText(i.currentPrice)
      })
    },

    // 获取有效滚动高度（已完成的）
    getComValidScrollH() {
      this.$nextTick(() => {
        if (this.completeDynamicData.length) {
          this.comValidScrollH =
            this.$refs.dataW.offsetHeight -
            this.$refs?.ongoingW?.$el.offsetHeight -
            this.colTitleH

          console.log('ongoingW', this.$refs?.ongoingW.$el)
        } else {
          this.comValidScrollH = this.$refs.dataW.offsetHeight - this.colTitleH
        }

        console.log('getComValidScrollH', this.comValidScrollH)
      })
    },

    // 处理竞拍大厅数据
    setListData(data, timerKey) {
      for (const i in data) {
        this.setCountdown(data, i, timerKey)
      }
    },
    // 初始化 socket连接
    initSocket(data, timerKey) {
      this.websocket = new MySocket({
        url: process.env.VUE_APP_WS_API
      })
      this.websocket.doConnect().then(() => {
        data.forEach((item, index) => {
          if (!this.isProjectEnd(item.auctionState)) {
            this.websocket.doSubscribe(
              '/topic/auction/' + item.projectNo,
              (msg) => {
                // 订阅列表的每条消息
                this.onHandleSocketResEvent(
                  data,
                  index,
                  JSON.parse(msg.body),
                  timerKey
                )
              }
            )
          }
        })
      })

      if (data.length) {
        window.addEventListener(
          'online',
          (this.handleWsOnline = this.handleWsOnline.bind(null, data))
        )
      }
      window.addEventListener('offline', this.handleWsOffline)
    },
    // 处理网络在线
    handleWsOnline(data) {
      this.websocket = new MySocket({
        url: process.env.VUE_APP_WS_API
      })
      this.websocket.doConnect().then(() => {
        data.forEach((item, index) => {
          this.websocket.doSubscribe(
            '/topic/auction/' + item.projectNo,
            (msg) => {
              // 订阅列表的每条消息
              this.socketDataRes = JSON.parse(msg.body)
              this.onHandleSocketResEvent(this.socketDataRes.event)
            }
          )
        })
        this.$notify({
          type: 'success',
          title: '提示',
          message: '连接成功。',
          duration: 5000
        })
      })
    },
    // 处理网络离线
    handleWsOffline() {
      this.websocket?.stompClient?.disconnect()
      this.$notify({
        type: 'warning',
        title: '提示',
        message: '网络异常，正在尝试重新连接...',
        duration: 5000
      })
    },
    // 处理socket响应的事件
    onHandleSocketResEvent(data, index, resBody, timerKey) {
      switch (resBody.event) {
        case 'stateChange':
          this.handleStateChange(data, index, resBody, timerKey)
          break
        case 'delayed':
          this.handleDelayed(data, index, resBody, timerKey)
          break
        case 'bid':
          this.handleBid(data, index, resBody)
          break
        case 'end':
          this.handleEnd(data, index, resBody)
          break
      }
    },
    // 处理-项目状态
    handleStateChange(data, index, resBody, timerKey) {
      this.$set(data[index], 'auctionState', Number(resBody.auctionState))
      this.$set(data[index], 'auctionStateDesc', resBody.stateDesc)
      this.$set(data[index], 'sysDate', resBody.sysDate)
      this.$set(data[index], 'state', resBody.state)
      this.setCountdown(data, index, timerKey)

      this.uploadScrollList(data[index])
    },
    // 处理-项目延时
    handleDelayed(data, index, resBody, timerKey) {
      this.$set(data[index], 'sysDate', resBody.sysDate)
      this.$set(data[index], 'auctionEndTime', resBody.endTime)
      this.setCountdown(data, index, timerKey)
    },
    // 处理-出价
    handleBid(data, index, resBody) {
      this.$set(data[index], 'currentPrice', resBody.currentPrice)
    },
    // 处理-项目结束
    handleEnd(data, index, resBody) {
      this.$set(data[index], 'state', resBody.state)
      this.$set(data[index], 'auctionState', Number(resBody.auctionState))
      this.$set(data[index], 'auctionStateDesc', resBody.stateDesc)
      this.$set(data[index], 'stateEndTime', resBody.endTime)
      this.$set(data[index], 'remark', resBody.remark)

      this.uploadScrollList(data[index])
    },
    // 更新列表状态（已结束，进行中）
    uploadScrollList(item) {
      if ([4, 5].includes(item.auctionState)) {
        const itemIndex = this.ongoingDynamicData.findIndex(
          (i) => i.projectNo === item.projectNo
        )

        if (itemIndex !== -1) {
          this.ongoingDynamicData.splice(itemIndex, 1)
        }
        this.completeDynamicData.unshift(item)
      }

      // 进行中的
      this.setListData(this.ongoingDynamicData, 'completeCountTimer')
      // 已完成的
      this.setListData(this.completeDynamicData, 'ongoingCountTimer')
    },

    // 设置倒计时
    setCountdown(data, index, timerKey) {
      data[index].diffMs =
        new Date(tranTimeFormat(data[index].auctionEndTime)).getTime() -
        new Date(tranTimeFormat(data[index].sysDate)).getTime() -
        500

      if (data[index]?.diffMs <= 500) {
        this.$set(data[index], 'd', 'x')
        this.$set(data[index], 'h', 'x')
        this.$set(data[index], 'm', 'x')
        this.$set(data[index], 's', 'x')
        return
      }

      data[index][timerKey] && clearInterval(data[index][timerKey])

      data[index][timerKey] = setInterval(() => {
        data[index].diffMs -= 1000

        this.initCountdownTime(data, index, timerKey)

        if (data[index]?.diffMs <= 0) {
          clearInterval(data[index]?.[timerKey])
        }
      }, 1000)
    },
    // 初始时间倒计时（根据不同状态的时间计算）
    initCountdownTime(data, index, timerKey) {
      // if (!data.length) return

      let remain = null // 剩余

      this.$set(
        data[index],
        'd',
        Math.floor(data[index]?.diffMs / (24 * 3600 * 1000))
      ) // 剩余天
      remain = data[index]?.diffMs % (24 * 3600 * 1000)

      this.$set(data[index], 'h', Math.floor(remain / (3600 * 1000))) // 剩余小时
      remain = remain % (3600 * 1000)

      this.$set(data[index], 'm', Math.floor(remain / (60 * 1000))) // 剩余分
      remain = remain % (60 * 1000)

      this.$set(data[index], 's', Math.floor(remain / 1000)) // 剩余秒
      remain = remain % 1000

      // console.log(data[index].d, data[index].h, data[index].m, data[index].s)
    },

    // 设置刷新倒计时（每3分钟刷新一次）
    async setRefreshCountDown() {
      this.refreshTime && clearInterval(this.refreshTime)
      this.refreshTime = setInterval(async() => {
        this.getAuctionDynamicData()
      }, 1000 * 60 * 3)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-enter,
.v-leave-to {
  opacity: 0;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 1s;
}

.auctionDynamic-w {
  position: relative;
  margin: 15px 0 0 0;
  height: 803px;
  color: #fff;
  &::-webkit-scrollbar {
    display: none;
  }
  & {
    scrollbar-width: none; //火狐
  }
  .col-title-w {
    position: absolute;
    left: 0;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    z-index: 2;

    & > .col-i {
      text-align: center;
      padding: 12px 0;
      font-size: 16px;

      font-weight: bold;

      background: #3b3a66;
    }
  }
  .data-c-w {
    overflow: hidden;
    position: absolute;
    left: 0;
    width: 100%;
    height: 637px;
    background-color: rgba($color: #343265, $alpha: 0.5);
    &::-webkit-scrollbar {
      display: none;
    }
    & {
      scrollbar-width: none; //火狐
    }
  }
  .ongoing_data_w {
  }
  .complete_data_w {
    overflow: hidden;
  }
  .row-data-w {
    display: flex;
    cursor: pointer;
    height: 50px;
    line-height: 50px;
    &:hover {
      text-decoration: underline;
    }
    & > .row-i {
      padding: 0 15px;
      font-size: 16px;
      font-weight: 400;
    }
  }
  .title {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 12px 0 21px 0;
    letter-spacing: 3px;
    text-align: center;
    font-size: 28px;

    font-weight: bold;
    color: #fff;
    background: rgba($color: #292850, $alpha: 1)
      url("../assets/images/bigdata_2.png") center 0 / contain no-repeat;
    z-index: 3;
  }
  .status-w {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 59px;
    right: 0;
    left: 0;
    bottom: 0;
    text-align: center;
    background-color: rgba($color: #343265, $alpha: 0.5);

    .state-i {
      display: flex;
      align-items: center;
    }
    .state-icon {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }
    .state-des {
      letter-spacing: 1px;
      margin-left: 8px;
      font-size: 16px;

      font-weight: 400;
    }
  }

  .span_1 {
    margin: 0 4px 0 0;
  }
}
//文本省略
.text-omit {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
//未开始
.deal_state_0 {
  color: #fff;
}
//进行中
.deal_state_1 {
  color: #e0de1e;
}
//已结束
.deal_state_2 {
  color: #fc3e3e;
}
</style>
